import React, { useState, useEffect, useRef } from "react";
import icons from "../../assets/icons/icons";
import color from "../../assets/colors";
import ProductSpecificationWidget from "../ProductSpecificationWidget/ProductSpecificationWidget";
import { connect } from "react-redux";
import config from "../../config/config";
import API from "../../services/httpService";
import appService from "../../services/appService";
import { eventAddToCart } from "../../helpers/events";
import ContentPopup from "../contentPopup/contentPopup";
import WhiteGloveAssembly from "../whiteGloveAssembly/whiteGloveAssembly";
import Link from "next/link";
import Slider from "react-slick";
import AffirmPrequalify from "../AffirmPrequalify/AffirmPrequalify";
import httpService from "../../services/httpService";

declare const window: any;
function BundlePopUpElite({
  onCloseHandler,
  data,
  onToggle,
  setCartItems,
  showLoader,
  hideLoader,
}: any) {
  const [resValues, setResValues] = useState(null);
  const [specRes, setSpecRes]: any[] = useState([]);
  const [VariantOptions, setVarOptions]: any[] = useState([]);
  const [cardIndex, setCardIndex] = useState(0);
  const [isClosed, setClosed] = useState(true);
  const [dataLinks, setDataLinks] = useState(null);
  const [showAssembly, setShowAssembly] = useState(false);
  const [assemblyData, setAssemblyData] = useState([]);

  // A new state is introduced which will store the product id of extend warranty
  const [extendWarrantyId,setExtendWarrantyId] = useState(undefined);

  // A function for rendering Extend Buttons in product page
  const renderExtendButton = async () => {
    //@ts-ignore
    window.Extend.buttons.destroyAll();
    //@ts-ignore
    await window.Extend.buttons.render(`#extend-product-${data.id}`, {
      referenceId: `${data.id}`,
    })
  }

  // To render Extend buttons when product data and extend warranty for the page is loaded
  useEffect( () => {
    if(extendWarrantyId!==undefined)
    {
      checkIfButtonsLoaded();
    }
  },[data,extendWarrantyId]);

  const checkIfButtonsLoaded = () => {
    if(document.getElementById(`extend-product-${data.id}`) !== null){
      //@ts-ignore
      if(window.Extend)
      {
        showLoader();
        renderExtendButton();  
      }
      checkIframeLoaded();  
    } else {
      window.setTimeout(checkIfButtonsLoaded, 100);
    }
  }

  // To check if the iframe has loaded
  const checkIframeLoaded =()=> {
    let iframe = document.querySelector(`#extend-product-${data.id} iframe`) as HTMLIFrameElement;
    if (iframe) {
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (iframeDoc.readyState  == 'complete' && iframeDoc.querySelector(".caption")) {
        const style = `
        <style>
          .caption {
            width: 100%!important;
            text-align: center!important;
          }
          .button-group {
            max-width: 500px!important;
            margin: auto!important;
          }
        </style>
        `;
        iframeDoc.head.innerHTML = iframeDoc.head.innerHTML + style;
        hideLoader();
        return;
      } 
    }
    // If we are here, it is not loaded. Set things up so we check the status again in 100 milliseconds
    window.setTimeout(checkIframeLoaded, 100);
  }

  const ref = useRef(null);
  const navRef = useRef(null);

  const cardtId = appService.getKey("cartid");

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
    beforeChange: function (oldIndex, index) {
      // context.handleTag(index);
      setCardIndex(index);
    },
    dotsClass: "slick-dots slick-thumb",
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    showLoader();
    API.invokeApi(
      {
        method: "get",
        url: `${config.endpoints.products}?title_eq=On Site Assembly`,
      },
      (success: boolean, res: any) => {
        if (success) {
          const finalRes =
            res &&
            res?.length > 0 &&
            res.filter((data) => data.title === "On Site Assembly");
          setAssemblyData(finalRes);
        }
      }
    );
    API.invokeApi(
      { method: "get", url: `${config.endpoints.productBundle}/${data.id}` },
      (success: boolean, res: any) => {
        if (success) {
          const specificationKeys = ["Details", "Specifications", "Warranty"];
          const prospc = [];
          specificationKeys.map((data) => prospc.push(res.product[data]));
          setResValues(res);
          setSpecRes(prospc);
          const opVariants = [];

          res &&
            res.Includes &&
            res.Includes?.length > 0 &&
            Array.isArray(res.Includes) &&
            res.Includes?.map((data, index) => {
              let tempValue = {};
              if (data.__component === "product.fixed-product") {
                if (data.selectedVariant) {
                  if (data.product.title === "Sit Up Bar") {
                    tempValue["product"] = data.product.id;
                    tempValue["variantLabel"] =
                      data.selectedVariant.variantLabel;
                    tempValue["selectedOption"] =
                      data.selectedVariant.selectedOption;
                    tempValue[
                      "variantKey"
                    ] = `0_${data.product.id}_${data.selectedVariant.variantLabel}`;
                    opVariants.push(tempValue);
                    tempValue = {};
                  } else {
                    for (let i = 0; i < data.selectedVariant.length; i++) {
                      tempValue["product"] = data.product.id;
                      tempValue["variantLabel"] =
                        data.selectedVariant[i].variantLabel;
                      tempValue["selectedOption"] =
                        data.selectedVariant[i].selectedOption;
                      tempValue[
                        "variantKey"
                      ] = `0_${data.product.id}_${data.selectedVariant[i].variantLabel}`;
                      opVariants.push(tempValue);
                      tempValue = {};
                    }
                  }
                } else {
                  if (index !== 0) {
                    for (let i = 0; i < data.quantity; i++) {
                      tempValue["product"] = data.product.id;
                      tempValue["variantKey"] = `0_${data.product.id}`;
                      opVariants.push(tempValue);
                      tempValue = {};
                    }
                  }
                }
              }
              if (data.__component === "product.choice-of-product") {
                for (let j = 0; j < data.selectedProduct.length; j++) {
                  tempValue["product"] = data.OptionalProducts[j].product.id;
                  tempValue["variantLabel"] =
                    data.selectedProduct[j].variantLabel;
                  tempValue["selectedOption"] =
                    data.selectedProduct[j].selectedOption;
                  tempValue[
                    "variantKey"
                  ] = `0_${data.OptionalProducts[j].product.id}_${data.selectedProduct[j].variantLabel}`;
                  opVariants.push(tempValue);
                  tempValue = {};
                }
              }
            });
          setVarOptions(opVariants);
          hideLoader();
        } else {
          hideLoader();
        }
      }
    );
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const GoogleAnalyticsAddToCart = () => {
    let prod = {};
    let price;
    let discount = data.newPrice !== null ? data.price - data.newPrice : 0;
    price = data.newPrice !== null ? data.newPrice : data.price;

    prod = {
      ...prod,
      id: data.id,
      name: data.displayTitle ? data.displayTitle : data.title,
      discount: discount ? +Math.abs(discount).toFixed(2) : 0,
      affiliation: "Nexersys Store",
      brand: "Nexersys",
      // item_category: 'pants',
      price: price,
      currency: data.currency
        ? data.currency.code
          ? data.currency.code
          : "USD"
        : "USD",
      quantity: 1,
    };

    const item = {
      currency: "USD",
      items: [prod],
      value: price,
    };
    eventAddToCart(item);
  };

  useEffect(()=>{
    showLoader()
    httpService.invokeApi(
      {
        url: `${config.endpoints.getExtendWarrantyType}?productType=Warranty&title=Extended Warranty`,
        method: 'get',
      }
      ,
      (success: boolean, res: any) => {
        if(success) {
          setExtendWarrantyId(res[0].id);
          hideLoader();
        } else {
          hideLoader();
        }
      }
    );
  },[]);

  const onSubmit = (event: any) => {
    const component = window.Extend.buttons.instance(`#extend-product-${data.id}`);
    const plan = component.getPlanSelection();
    showLoader();
    event.preventDefault();
    GoogleAnalyticsAddToCart();
    const request = { productBundleId: data.id, quantity: 1, VariantOptions };
    API.invokeApi(
      {
        method: "put",
        url: `${config.endpoints.getCart}/${cardtId}/cartitems`,
        data: request,
      },
      (success: boolean, res: any) => {
        if (success && res.id && plan) {
          httpService.invokeApi(
            {
              url: `${config.endpoints.getCart}/${cardtId}/cartitems`,
              method: 'put',
              data: {
                  productId: extendWarrantyId,
                  associatedBundleId: data.id,
                  quantity: 1,
                  planId: plan.planId,
                  price: plan.price/100,
                  duration: plan.term
              }
            },(success: boolean, res: any) => {
              const request: any = { method: "get", url: config.endpoints.getCart };
              if (cardtId) {
                request.headers = { cartid: cardtId };
              }
              API.invokeApi(request, (success: boolean, resp: any) => {
                if (success && resp.cartId) {
                  appService.setKey("cartid", resp.cartId);
                  setCartItems(resp);
                  hideLoader();
                } else {
                  hideLoader();
                }
                // onCloseHandler();
                onToggle();
              });
            })
        } else if (success && res.id && !plan) {
          // setVarOptions([]);
          const request: any = { method: "get", url: config.endpoints.getCart };
          if (cardtId) {
            request.headers = { cartid: cardtId };
          }
          API.invokeApi(request, (success: boolean, resp: any) => {
            if (success && resp.cartId) {
              appService.setKey("cartid", resp.cartId);
              setCartItems(resp);
              hideLoader();
            } else {
              hideLoader();
            }
            // onCloseHandler();
            onToggle();
          });
        } else {
          hideLoader();
        }
      }
    );
  };

  const optionalproduct = (optionalproduct: any) => {
    let items: any = [];
    optionalproduct?.map((productitems: any, i: number) => {
      items.push(productitems.product.displayTitle);
      return items.push(" or ");
    });
    items.pop();
    return items;
  };

  const onTogglerHandler = (data: any, text: string) => {
    if (text === "White Glove Assembly") {
      handleOpenAssembly();
    } else {
      setDataLinks(data);
      setClosed(!isClosed);
    }
  };

  const handleOpenAssembly = () => {
    setShowAssembly(true);
  };

  const handleHideAssembly = () => {
    setShowAssembly(false);
  };

  return (
    <>
      <div className="Bundle-overlay" style={{ zIndex: 1000 }}>
        <div className="Bundle-container">
          {resValues && (
            <div className="overlay-conatiner">
              <div className="overlay-wrapper">
                <span
                  className="bundle-close-icon"
                  onClick={onCloseHandler}
                  style={{ right: 1 }}
                >
                  {icons.close(color.$black, "")}
                </span>
                <div className="element-product-descp-wrapper">
                  <div className="product-descp-row">
                    <div className="product-descp-col">
                      <div className="product-desp-image-conatiner">
                        <Slider {...settings} ref={ref}>
                          {
                            // specRes && specRes?.product &&
                            data?.image &&
                              data?.image?.length > 0 &&
                              data?.image?.map((item, index) => (
                                <div key={index}>
                                  <img src={item?.url} alt="imgmg" />
                                </div>
                              ))
                          }
                        </Slider>
                        <p>
                          <span>Includes: </span>
                          {resValues?.Includes &&
                            resValues?.Includes?.length > 0 &&
                            resValues?.Includes?.map(
                              (items: any, i: number) => {
                                if (
                                  items.__component === "info.info-component"
                                ) {
                                  return <span key={i}>{items.label}</span>;
                                }
                                return (
                                  <span key={i}>
                                    {items.product?.title != null
                                      ? items.product?.title
                                      : optionalproduct(
                                          items.OptionalProducts
                                        )}{" "}
                                    {items.quantity != null
                                      ? "(" + items.quantity + "), "
                                      : null}
                                  </span>
                                );
                              }
                            )}
                        </p>
                        <div className="slider-elite-sub-nav">
                          {
                            // specRes && specRes?.product &&
                            data?.image &&
                              data?.image?.length > 0 &&
                              data?.image?.map((item, index) => (
                                <div
                                  className={`sub-nav-img-container ${
                                    cardIndex === index && "active"
                                  }`}
                                  key={index}
                                  onClick={(e) => ref.current.slickGoTo(index)}
                                >
                                  <img src={item?.url} alt="imgmg" />
                                </div>
                              ))
                          }
                        </div>
                      </div>
                    </div>
                    <div
                      className={`product-descp-col ${
                        !resValues.newPrice && `elite-align-col-center`
                      }`}
                    >
                      <div className="product-desp-info-conatiner">
                        <h2>{resValues?.displayTitle}</h2>
                        <h3>{resValues?.title}</h3>
                        <div className="price-conatiner">
                          {resValues?.newPrice ? (
                            <>
                              <div className="normal-price">{`$${resValues?.price}`}</div>
                              <div className="discounted-price">
                                <span> {`$${resValues?.newPrice}`} </span>
                                <span className="free-shipping">
                                  +Free Shipping
                                </span>
                              </div>
                              <div className="money-saved">
                                You Save{" "}
                                {`$${(
                                  resValues?.price - resValues?.newPrice
                                )?.toFixed(2)}`}{" "}
                              </div>
                            </>
                          ) : (
                            <div className="fighter-price-container">
                              <span>{`$${resValues?.price}`}</span>
                              <span className="free-shipping">
                                + Free Shipping
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="divider-wrapper-elite">
                          <div />
                        </div>
                        <div className="div-feature-includes-wrapper">
                          <h4> Includes </h4>
                          <ul className="div-feature-includes">
                            {resValues?.Includes &&
                              resValues?.Includes?.length > 0 &&
                              resValues.Includes?.map(
                                (items: any, i: number) => {
                                  if (
                                    items.__component ===
                                    "product.fixed-product"
                                  ) {
                                    return (
                                      <li key={i}>
                                        {items.product?.title != null &&
                                          items.product?.title}
                                        {items.quantity != null
                                          ? "(" + items.quantity + ")"
                                          : null}
                                      </li>
                                    );
                                  }
                                  if (
                                    items.__component ===
                                    "product.choice-of-product"
                                  ) {
                                    return (
                                      items.OptionalProducts &&
                                      items.OptionalProducts?.length > 0 &&
                                      items.OptionalProducts?.map((data, i) => (
                                        <li key={i}>
                                          {i === 0
                                            ? data.product?.title != null &&
                                              `10 oz.${data.product?.title}`
                                            : data.product?.title != null &&
                                              `Standard ${data.product?.title}`}
                                        </li>
                                      ))
                                    );
                                  }
                                }
                              )}
                          </ul>
                        </div>
                        {/* In the bottom div extend buttons are going to get rendered */}
                        <div className="extend-warranty-product-container">
                          <div id={`extend-product-${data.id}`}></div>
                        </div>
                        <br/>
                        <div className="product-elite-button-wrapper update-button-wrapper">
                          <a>
                            <button onClick={onSubmit}>ADD TO CART</button>
                          </a>
                        </div>
                        {resValues?.price > 0 && resValues?.price && (
                          <div className="n3-bundle-item">
                            <AffirmPrequalify
                              price={resValues.price}
                              newPrice={resValues.newPrice}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="elite-fqa-wrapper">
                    <ProductSpecificationWidget
                      n3Bundles={true}
                      data={specRes}
                    />
                  </div>
                  <div className="additional-links-wrapper">
                    <div className="additional-links-conatiner">
                      {resValues.product &&
                        resValues.product.AdditionalLinks &&
                        resValues.product.AdditionalLinks?.map(
                          (data, index) => (
                            <div className="data-addlink" key={index}>
                              {data.url ? (
                                <Link href={data.url}>
                                  <a>{data.text}</a>
                                </Link>
                              ) : (
                                <a
                                  onClick={() =>
                                    onTogglerHandler(
                                      data.description,
                                      data.text
                                    )
                                  }
                                >
                                  {data.text}
                                </a>
                              )}
                            </div>
                          )
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!isClosed && (
            <ContentPopup data={dataLinks} onCloseHandler={onTogglerHandler} />
          )}
        </div>
      </div>
      {showAssembly && (
        <WhiteGloveAssembly
          handleHideAssembly={handleHideAssembly}
          setCartItems={setCartItems}
          showLoader={showLoader}
          hideLoader={hideLoader}
          data={assemblyData}
        />
      )}
    </>
  );
}

const mapState = (state: any) => {
  return {
    status: state.cartStatus,
    cart: state.cart,
  };
};

const mapDispatch = (dispatch: any) => {
  return {
    onToggle: () => dispatch({ type: "TOGGLE_CART" }),
    setCartItems: (cartItems: any) => {
      dispatch({ type: "ON_CART_LOAD", payload: cartItems });
    },
    showLoader: () => dispatch({ type: "LOADER_SHOW" }),
    hideLoader: () => dispatch({ type: "LOADER_HIDE" }),
  };
};

export default connect(mapState, mapDispatch)(BundlePopUpElite);
